import axios from 'axios';
import * as actionTypes from '../constants/actions';

import baseUrl from '../utils/baseUrl';
let url = baseUrl + '/api/profiles/';

let busy = false;

function action(type) {
	return { type: type };
};

function respond(json, type) {
	//console.log(type);
	return {
		type: type,
		payload: json,
	};
};

export function flushProfile() {
	return function(dispatch) {
		// IF we want to remove the old one when leaving the component and returning?
		dispatch(action(actionTypes.PROFILES_CLEAR_DATA));
	};
}

export function fetchProfiles(offset = 0, limit = 36, q = '', order = '', orderBy = '') {
	let queryParams = {
		offset: offset,
		limit: limit,
		q: q,
		order: order,
		orderBy: orderBy,
	};

	if (busy) {
		return function(dispatch) {
			false;
		};
	}

	return function(dispatch) {
		busy = true;
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_DATA));
			busy = false;
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));
			console.log('profiles - fetch error');
			console.log(response);
			busy = false;

			//dispatch(pushState(null, '/error'));
		});
	};
};

export function fetchSingleProfile(slug) {
	if (!(typeof slug === 'number' || (typeof slug === 'string' && slug.length))) {
		console.log('profiles - invalid slug');
		return function(dispatch) {
			//dispatch(pushState(null, '/error'));
		};
	}

	return function(dispatch) {
		dispatch(action(actionTypes.PROFILES_REQ_SINGLE_DATA));
		return axios({
			url: url + slug,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_SINGLE_DATA));
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));

			console.log('profile - fetch error');
			console.log(response);

			//dispatch(pushState(null, '/error'));
		});
	};
}

export function fetchProfileCases(slug) {
	if (!(typeof slug === 'number' || (typeof slug === 'string' && slug.length))) {
		console.log('profiles - invalid slug');
		return function(dispatch) {
			//dispatch(pushState(null, '/error'));
		};
	}

	return function(dispatch) {
		return axios({
			url: url + slug + '/related',
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_CASE_DATA));
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.PROFILES_RECV_ERROR));

			console.log('profile - fetch error');
			console.log(response);

			//dispatch(pushState(null, '/error'));
		});
	};
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/profiles.js
 **/